module.exports = __webpack_public_path__ + "img/login_260730.05b6dd4a.png";